module.exports = __webpack_public_path__ + "static/stamp-animation-1849820d7cf5b0dfcc191a77acdb5968.gif";